export const GET_INTREST_BILL_ADJUSTMENTS = 'GET_INTREST_BILL_ADJUSTMENTS';
export const SET_INTREST_BILL_ADJUSTMENTS = 'SET_INTREST_BILL_ADJUSTMENTS';
export const INTREST_BILL_ADJUSTMENT_REQUEST = 'INTREST_BILL_ADJUSTMENT_REQUEST';
export const RESET_INTREST_BILL_ADJUSTMENTS = 'RESET_INTREST_BILL_ADJUSTMENTS';
export const INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE = 'INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE';